import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectRelationalItemBean } from "../../../beans";
import { LinkedPageObjectTranslator, LinkedPageObjectTranslateOption } from "./LinkedPageObjectTranslator";
import { ILinkedObjectTranslatable } from "./ILinkedObjectTranslatable";

export class LegacyLinkedPageObjectTranslator implements ILinkedObjectTranslatable<ILinkedPageObjectSpecifiable> {
  constructor(option?: LinkedPageObjectTranslateOption) {
    this.base = new LinkedPageObjectTranslator(option);
  }

  from(bean: IXElementContentsObjectRelationalItemBean): ILinkedPageObjectSpecifiable {
    return this.base.from(bean);
  }

  to(object: ILinkedPageObjectSpecifiable): IXElementContentsObjectRelationalItemBean {
    const result = this.base.to(object);
    result["@obj-id"] = undefined;  // 古い版で実装されたrelationalitem用.@obj-idは未指定なので削除する.
    return result;
  }

  private readonly base: LinkedPageObjectTranslator;
}
